import { render, staticRenderFns } from "./subjectsApplied.vue?vue&type=template&id=827093fe&scoped=true"
import script from "./subjectsApplied.vue?vue&type=script&lang=js"
export * from "./subjectsApplied.vue?vue&type=script&lang=js"
import style0 from "./subjectsApplied.vue?vue&type=style&index=0&id=827093fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827093fe",
  null
  
)

export default component.exports